/* eslint-env jest */
import relatedProducts, { MAX_RELATED } from './relatedProducts';

const addon = (name, cssName, giftCategory) => ({ name, cssName, giftCategory });

const PLAID = addon('Plaid', 'gradplaid', 'announcements');
const CURSIVE = addon('Cursive', 'gradcursive', 'announcements');
const BOHO = addon('Boho', 'gradbrown', 'announcements');
const MAGNETS = addon('Photo Magnets', 'magnet', 'magnets');
const MUG = addon('Coffee Cup', 'coffeecup', 'gifts');
const KEYCHAIN = addon('Photo Keychain', 'keychain', 'gifts');
const WALLETS = addon('(8) Wallets', 'wallets', 'prints');
const FIVEBYSEVEN = addon('(2) 5x7s', 'fivebyseven', 'prints');

// Eight products, so "everything else" (seven) EXCEEDS the limit and the cap
// actually bites -- with a catalogue the size of the limit the length
// assertions below would pass whether or not one existed.
const CATALOG = [PLAID, CURSIVE, BOHO, MAGNETS, MUG, KEYCHAIN, WALLETS, FIVEBYSEVEN];

describe('relatedProducts', () => {
  it('offers the rest of the product\'s own category first', () => {
    const related = relatedProducts(CATALOG, PLAID);

    expect(related.slice(0, 2).map((a) => a.name)).toEqual(['Cursive', 'Boho']);
  });

  it('never offers the product the customer is already looking at', () => {
    expect(relatedProducts(CATALOG, PLAID).map((a) => a.cssName)).not.toContain('gradplaid');
  });

  // A variant family shares one css_name -- senior and elementary wallets are
  // two rows, one product screen. Offering the other audience's row would point
  // at a product this customer cannot buy.
  it('excludes an other-audience twin sharing the css_name', () => {
    const elementaryWallets = addon('(8) Wallets', 'wallets', 'prints');
    const related = relatedProducts([...CATALOG, elementaryWallets], WALLETS);

    expect(related.map((a) => a.cssName)).not.toContain('wallets');
  });

  // THE CASE CATEGORY-ONLY GETS WRONG. For a senior, Magnets holds exactly one
  // product, so its own screen would otherwise show an empty row.
  it('tops up from the rest of the catalogue when a category holds one product', () => {
    const related = relatedProducts(CATALOG, MAGNETS);

    expect(related).toHaveLength(MAX_RELATED);
    expect(related.map((a) => a.cssName)).not.toContain('magnet');
  });

  it('keeps the arriving pricelist order within each group', () => {
    const related = relatedProducts(CATALOG, MUG, 10);

    // Same category first (the keychain), then everything else in catalogue order.
    expect(related.map((a) => a.name)).toEqual([
      'Photo Keychain', 'Plaid', 'Cursive', 'Boho', 'Photo Magnets', '(8) Wallets', '(2) 5x7s',
    ]);
  });

  it('honours the limit', () => {
    expect(relatedProducts(CATALOG, PLAID, 2)).toHaveLength(2);
    expect(relatedProducts(CATALOG, PLAID)).toHaveLength(MAX_RELATED);
  });

  it('returns nothing rather than throwing when there is no product or catalogue', () => {
    expect(relatedProducts(CATALOG, null)).toEqual([]);
    expect(relatedProducts([], PLAID)).toEqual([]);
    expect(relatedProducts()).toEqual([]);
  });

  // A single-product catalogue is a real state (an elementary school with one
  // gift on the pricelist); the row must simply not render.
  it('returns nothing when the catalogue holds only this product', () => {
    expect(relatedProducts([PLAID], PLAID)).toEqual([]);
  });
});
